import React, { useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import convertToExcel from "../../../components/ExportToExcel";

const NurseryStock = () => {
  const [stockData, setStockData] = useState();
  const [wareHouseData, setWareHouseData] = useState();
  const [allData, setAllData] = useState([]);

  const { sendRequest: getWarehouseStock } = useHttp();

  const loadStockData = (id) => {
    const orgId = localStorage.getItem("orgId");

    let url = `/api/getNurseryWiseStock/?orgId=${orgId}`;
    if (id) {
      url += `&nurseryId=${id}`;
    }

    getWarehouseStock(
      {
        url,
        method: "GET",
      },
      (res) => {
        if (res) {
          setStockData(res);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    loadStockData();
  }, [getWarehouseStock]);

  const handleSearch = (e) => {
    var filetrtext = e.target.value.trim().toLowerCase();
    //console.log(filetrtext);
    console.log("allData", allData);
    var filterdata = allData.filter(
      (item) =>
        item?.itemId?.toString().toLowerCase().includes(filetrtext) ||
        item?.productName?.toString().toLowerCase().includes(filetrtext) ||
        item?.productSubTypeName
          ?.toString()
          .toLowerCase()
          .includes(filetrtext) ||
        item?.productTypeName?.toString().toLowerCase().includes(filetrtext) ||
        item?.lotNo?.toString().toLowerCase().includes(filetrtext) ||
        item?.batchNo?.toString().toLowerCase().includes(filetrtext)
    );
    console.log("filtes", filterdata);
    setStockData(filterdata);
  };

  const { sendRequest: getWarehouseData } = useHttp();

  const getWarehouseDetail = () => {
    getWarehouseData(
      {
        // url: "/api/warehouses/",
        url: `/api/warehouses/?orgId=${localStorage.getItem(
          "orgId"
        )}&&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          // //console.log(res);
          setWareHouseData(res);
        }
      }
    );
  };

  useEffect(() => {
    getWarehouseDetail();
  }, [getWarehouseData]);

  const handleWarehouseChange = (e) => {
    // //console.log(e.target.value);
    const id = e.target.value;
    loadStockData(id);
  };

  const [itemsPerPage] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems =
    stockData && stockData.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const fieldsToExport = [
    "itemId",
    "productName",
    "productSubType",
    "productTypeName",
    "batchNo",
    "productQuantity",
    "unitAbbreviation",
    "containerQuantityBal",
    "containerName",
    "Age",
  ];

  const customHeaders = [
    "Item Id",
    "Product Name",
    "Product Item Sub Type",
    "Product Item Type",
    "Batch No",
    "Seedling Quantity",
    "Unit",
    "Container Qty",
    "Container Name",
    "Age (days)",
  ];

  const handleExportExcel = () => {
    const filename = "getNurseryWiseStock.xlsx";
    //console.log(fieldsToExport, customHeaders);

    convertToExcel(stockData, fieldsToExport, filename, customHeaders);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-3">
            <label className="card-title mx-3 my-3">Nursery Stock</label>
          </div>
          <div className="col-3 mt-2">
            <select className="form-control" onChange={handleWarehouseChange}>
              <option value="0"> Select Warehouse</option>

              {wareHouseData &&
                wareHouseData.map((x) => (
                  <option key={x.id} value={x.id}>
                    {x.name}
                  </option>
                ))}
            </select>
          </div>
          <div className="col-3  mt-2">
            {" "}
            <input
              type="text"
              name="q"
              className="form-control"
              placeholder="Search..."
              onKeyUp={(e) => {
                handleSearch(e);
              }}
            />{" "}
            <br />
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <div className="text-right my-2">
                      <button
                        type="button"
                        className="btn btn-sm btn-warning"
                        onClick={handleExportExcel}
                      >
                        <i className="fas fa-file-excel"></i>
                      </button>
                    </div>
                    <table className="table table-responsive table-bordered text-center">
                      <thead>
                        <tr>
                          <th>Item Id</th>
                          <th>Product Name</th>
                          <th>Product Item Sub Type</th>
                          <th>Product Item Type</th>
                          <th>Batch No</th>
                          <th>Seedling Quantity </th>
                          <th>Unit</th>
                          <th>container Qty </th>
                          <th>Container Name</th>
                          <th>Age(days)</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.itemId}</td>
                                <td>{itm.productName}</td>
                                <td>{itm.productSubType}</td>
                                <td>{itm.productTypeName}</td>
                                <td>{itm.batchNo}</td>
                                <td>{itm.productQuantityBal}</td>
                                <td>{itm.unitAbbreviation}</td>
                                <td>{itm.containerQuantityBal}</td>
                                <td>{itm.containerName}</td>
                                <td>{itm.Age}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={stockData && stockData.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default NurseryStock;
